import * as angular from 'angular';
import { AttendanceConfigService } from './sdc-configs/attendance-config.service';
import { CreditGapsConfigService } from './sdc-configs/credit-gaps-config.service';
import { DefaultSdcConfigService } from './sdc-configs/default-sdc-config.service';
import { GradPlanningConfigService } from './sdc-configs/grad-planning-config.service';
import { MarkingPeriodConfigService } from './sdc-configs/marking-period-config.service';
import { NextTermPlanningConfigService } from './sdc-configs/next-term-planning-config.service';
import { PendingCourseGapPlanTableConfigService } from './sdc-configs/pending-course-gap-plan-table-config.service';
import { RegentsPlanningConfigService } from './sdc-configs/regents-planning-config.service';
import { RegentsPrepConfigService } from './sdc-configs/regents-prep-config.service';
import { SdcStateService } from './sdc-state.service';

export const SdcStateModule = angular
  .module('SdcStateModule', [])
  .service('AttendanceConfigService', AttendanceConfigService)
  .service('CreditGapsConfigService', CreditGapsConfigService)
  .service('DefaultSdcConfigService', DefaultSdcConfigService)
  .service('GradPlanningConfigService', GradPlanningConfigService)
  .service('MarkingPeriodConfigService', MarkingPeriodConfigService)
  .service('PendingCourseGapPlanTableConfigService', PendingCourseGapPlanTableConfigService)
  .service('RegentsPlanningConfigService', RegentsPlanningConfigService)
  .service('RegentsPrepConfigService', RegentsPrepConfigService)
  .service('SdcStateService', SdcStateService)
  .service('NextTermPlanningConfigService', NextTermPlanningConfigService).name;
